import _ from 'lodash';
//import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import RailcarContainer from '../../containers/railcars/Railcars';
import AuthUserContainer from '../../containers/AuthUser';
import PopOver from '../../components/ui/PopOver';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import { Typography } from '@material-ui/core';
// import OpenLink from '@material-ui/icons/OpenInNew';

import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';

import ResourcePopup from '../../components/Dialogs/ResourcePopup';
import invoiceIcon from '../../images/invoicePdf.svg';

import FMPText from '../../components/pureForm/FMPText';
import RailcarTerminalMultiSelect from './RailcarTerminalMultiSelect';
import { ingestedTerminalIds } from './constants';
import FormComponent from '../../components/FormComponent';
import { filterByTerminal } from './RailcarComponents';

const formatNum = new Intl.NumberFormat('en-US', {
	//style: 'currency',
	//currency: 'USD',
	minimumFractionDigits: 0,
}).format;

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

const columns = [
	/*
	{
		sortId: 'railcarId',
		displayId: 'railcarId',
		label: 'ID',
	},
	*/

	{
		sortId: 'terminalDisplay',
		displayId: 'terminalDisplay',
		label: 'Terminal',
	},

	{
		sortId: 'railroadSupplierDisplay',
		displayId: 'railroadSupplierDisplay',
		label: 'Railcar / Supplier',
	},

	{
		sortId: 'requestedMonthNumberSort',
		displayId: 'requestedMonthNumberDisplay',
		labels: ['Mon (#)'],
	},
	{
		sortId: 'fuelContractId',
		displayId: 'fuelContractIdDisplay',
		label: 'FMP Contract ID',
	},
	{
		sortId: 'railcarNumber',
		displayId: 'railcarNumber',
		label: 'Railcar #s',
	},
	{
		sortId: 'bol',
		displayId: 'bol',
		label: 'BOL',
	},
	{
		sortId: 'netGallons',
		displayId: 'gallonsDisplay',
		label: 'Gallons',
	},
	{
		sortId: 'shipDate',
		displayId: 'shipDateDisplay',
		labels: ['Ship Dates'],
	},
	{
		sortId: 'etaDate',
		displayId: 'etaDateDisplay',
		labels: ['ETA', 'CP & AP'],
	},
	{
		sortId: 'emptyDate',
		displayId: 'emptyDateDisplay',
		labels: ['Empty', 'Released'],
	},
	{
		sortId: 'lastStatusSort',
		displayId: 'lastStatusDisplay',
		labels: ['Status'],
	},
	{
		sortId: 'archiveAction',
		displayId: 'archiveAction',
		label: 'Action',
	},
];

function fmtDate(d) {
	if (!d) {
		return '-';
	}

	return moment(d).format('MMM-D');
}

function breakStatusIntoArray(status) {
	if (!status) {
		return ['-'];
	}
	// Split the string by '> ' to separate each date-location entry.
	const statuses = _.compact(status.split('>').map((entry) => entry.trim()));
	return statuses;
}

function filterBySearchString(data, searchString) {
	const searchLower = searchString.toLowerCase();

	return data.filter((item) => {
		if (item.railcarNumber && item.railcarNumber.toLowerCase().includes(searchLower)) {
			return true;
		}
		if (item.bol && item.bol.toString().toLowerCase().includes(searchLower)) {
			return true;
		}
		return false;
	});
}

const SETTINGS_KEY = 'railcarListingSettings';
const LF_ENERGY_SUPPLIER_ID = 5;
//- Columns externals never see: contract linkage + the archive mutation.
const EXTERNAL_HIDDEN_COLUMN_IDS = ['fuelContractId', 'archiveAction'];
class RailcarListing extends FormComponent {
	constructor(props) {
		super(props);
		console.log('props', this.props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'current');
		const startingTabIndex = { current: 0, issued: 1, invalid: 2 }[startingTab] || 0;

		let terminalIds = ingestedTerminalIds;
		if (localStorage.getItem(SETTINGS_KEY)) {
			try {
				const savedSettings = JSON.parse(localStorage.getItem(SETTINGS_KEY));
				if (savedSettings && savedSettings.terminalIds) {
					terminalIds = savedSettings.terminalIds;
				}
			} catch (e) {
				console.error('problems fetching settings from local storage', e);
			}
		}

		this.state = {
			tabIndex: startingTabIndex,
			order: 'desc',
			orderBy: 'requestedMonthNumberSort',
			search: '',
			filterMap: {},
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
			isInvalidOpen: false,
			terminalIds,
			archiveDialogOpen: false,
			archivingRailcarId: null,
		};
	}

	componentDidMount() {
		const { railcars, railcarSearch, isExternalReporting } = this.props;

		if (isExternalReporting) {
			//- Externals (LF Energy/ZFS) only get LF Energy cars; always refetch with the
			//- filter rather than trusting whatever is already in the store.
			railcarSearch({ params: { supplierId: LF_ENERGY_SUPPLIER_ID } });
		} else if (!railcars) {
			railcarSearch({});
		} else {
			this.railcarFormat();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { railcars } = this.props;

		if (prevState.terminalIds !== this.state.terminalIds) {
			localStorage.setItem(SETTINGS_KEY, JSON.stringify({ terminalIds: this.state.terminalIds }));
		}

		if (prevProps.railcars !== railcars) {
			this.railcarFormat();
		}
	}

	railcarFormat = () => {
		const {
			railcars,
			terminalMap,
			supplierMap,
			//apGuideMap,
		} = this.props;

		const rows = [];
		railcars.forEach((railcar) => {
			const {
				railcarId,
				terminalId,
				supplierId,
				railroad,
				fuelSupplier,
				requestedMonth,
				requestedNumber,
				product,
				// railcarNumber,
				// bol,
				netGallons,
				grossGallons,
				requestedShipDate,
				actualShipDate,
				etaDate,
				cpDate,
				apDate,
				inTransitDays,
				emptyDate,
				relinquishedDate,
				onSiteDays,
				currentStatus,
				fuelContractId,
			} = railcar;

			const terminal = terminalMap[terminalId] || { name: 'Missing' };
			const supplier = supplierId ? _.get(supplierMap, supplierId) : undefined;

			let supplierText = '';
			if (supplier) {
				supplierText = supplier.shortName || supplier.name;
			} else if (supplierId) {
				supplierText = `Missing (${supplierId})`;
			} else {
				supplierText = `Unmatched Supplier`;
			}

			railcar.terminalDisplay = (
				<div>
					{terminal.name}
					<br />
					<span style={{ fontSize: '90%' }}>Product : {product}</span>
				</div>
			);
			railcar.railroadSupplierDisplay = (
				<>
					{railroad}
					<br />
					{supplierText || fuelSupplier || ''}
					{fuelSupplier ? (
						<>
							<br />
							<span style={{ fontSize: '85%', color: '#666' }}>({fuelSupplier})</span>
						</>
					) : null}
				</>
			);

			// Convert number to string and pad it
			const paddedNumber = _.padStart((1000 - requestedNumber || 0).toString(), 3, '0');
			const requestedMonthDisplay = moment(requestedMonth).format('MMM');
			railcar.requestedMonthNumberDisplay = `${requestedMonthDisplay} (#${requestedNumber})`;
			railcar.requestedMonthNumberSort = `${requestedMonth}_${paddedNumber}`;

			railcar.gallonsDisplay = (
				<div style={{ whiteSpace: 'nowrap' }}>
					Net: {formatNum(netGallons)}
					<br />
					Gross: {formatNum(grossGallons)}
				</div>
			);

			railcar.shipDateDisplay = (
				<div style={{ whiteSpace: 'nowrap' }}>
					Req: {fmtDate(requestedShipDate)}
					<br />
					Actual: {fmtDate(actualShipDate)}
				</div>
			);
			railcar.etaDateDisplay = (
				<div style={{ whiteSpace: 'nowrap' }}>
					ETA: {fmtDate(etaDate)}
					<br />
					CP: {fmtDate(cpDate)}
					<br />
					AP: {fmtDate(apDate)}
				</div>
			);

			railcar.emptyDateDisplay = (
				<div style={{ whiteSpace: 'nowrap' }}>
					Empty: {fmtDate(emptyDate)}
					<br />
					Relinq: {fmtDate(relinquishedDate)}
				</div>
			);

			const statuses = breakStatusIntoArray(currentStatus) || [];
			const lastStatus = _.last(statuses) || 'Empty status';

			railcar.lastStatusSort = lastStatus;
			railcar.lastStatusDisplay = (
				<div>
					<PopOver
						style={{
							justifyContent: 'flex-start',
						}}
						value={
							<div>
								<div style={{ borderBottom: '1px solid #ccc', marginBottom: '5px' }}>
									In Transit: {inTransitDays} days
									<br />
									On Site: {onSiteDays} days
								</div>
								<div style={{ whiteSpace: 'pre', fontSize: '80%' }}>{statuses.join('\n')}</div>
							</div>
						}
					>
						<div>{lastStatus}</div>
					</PopOver>
				</div>
			);

			railcar.fuelContractIdDisplay = fuelContractId ? (
				fuelContractId
			) : (
				<span style={{ color: '#c00' }}><span role="img" aria-label="warning">⚠️</span> Empty</span>
			);

			railcar.archiveAction = (
				<IconButton
					size="small"
					style={{ color: '#c00' }}
					onClick={() => this.handleArchiveClick(railcarId)}
				>
					<ArchiveOutlinedIcon />
				</IconButton>
			);

			railcar.key = railcarId;
			rows.push(railcar);
		});
		this.setState({ rows });
	};

	handleArchiveClick = (railcarId) => {
		this.setState({ archiveDialogOpen: true, archivingRailcarId: railcarId });
	};

	handleArchiveCancel = () => {
		this.setState({ archiveDialogOpen: false, archivingRailcarId: null });
	};

	handleArchiveConfirm = () => {
		const { railcarHide, railcarSearch } = this.props;
		const { archivingRailcarId } = this.state;

		railcarHide({
			params: { railcarId: archivingRailcarId },
			callback: (err) => {
				if (err) {
					return;
				}
				this.setState({ archiveDialogOpen: false, archivingRailcarId: null });
				railcarSearch({});
			},
		});
	};

	handleView = (railcarId) => {
		this.props.history.push(`/billing/railcar/view/${railcarId}`);
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handlePdfClick = (resourceId) => {
		this.setState({
			resourceIdsPoppedUp: [resourceId],
			isResourcePopupOpen: true,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	render() {
		const { classes, resourceMap, isExternalReporting } = this.props;
		const { rows, order, orderBy, archiveDialogOpen } = this.state;
		const { quickFilterRailcar, terminalIds } = this.state;

		if (!rows) {
			return <div>Loading the railcar listing...</div>;
		}

		let filteredRows = filterByTerminal(rows, terminalIds);
		if (quickFilterRailcar && quickFilterRailcar.length >= 3) {
			filteredRows = filterBySearchString(filteredRows, quickFilterRailcar);
		}

		let visibleColumns = columns;
		if (isExternalReporting) {
			filteredRows = filteredRows.filter(({ supplierId }) => supplierId === LF_ENERGY_SUPPLIER_ID);
			visibleColumns = columns.filter(
				({ sortId }) => !_.includes(EXTERNAL_HIDDEN_COLUMN_IDS, sortId)
			);
		}

		return (
			<>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Grid container spacing={3}>
							<Grid item xs={8}>
								<Typography variant="h5" align="left" gutterBottom className={classes.title}>
									<span>Railcar Listing</span>
								</Typography>
							</Grid>
						</Grid>

						<Paper className={classes.paper} style={{ marginBottom: 10 }}>
							<div style={{ display: 'flex' }}>Quick Filter</div>

							<Grid spacing={2} container style={{ alignItems: 'flex-start' }}>
								<Grid item xs={6} style={{ textAlign: 'left' }}>
									<Grid spacing={2} container style={{ alignItems: 'flex-start', paddingTop: '7px' }}>
										<FMPText {...this.setForm(`quickFilterRailcar`, 'Railcar # or BOL')} />
									</Grid>
								</Grid>
								<Grid item xs={6} style={{ textAlign: 'left' }}>
									<Grid spacing={2} container style={{ alignItems: 'flex-start' }}>
										<RailcarTerminalMultiSelect
											{...this.setForm(`terminalIds`, 'Terminal Select', false, ingestedTerminalIds)}
										/>
									</Grid>
								</Grid>
							</Grid>
						</Paper>

						<Paper className={classes.paper}>
							<EnhancedTable
								columns={visibleColumns}
								rows={filteredRows}
								defaultOrder={order}
								defaultOrderBy={orderBy}
							/>

							<ResourcePopup
								open={this.state.isResourcePopupOpen}
								onClose={this.handleCloseResourcePopup}
								resourceIds={this.state.resourceIdsPoppedUp}
								resourceMap={resourceMap}
							/>
						</Paper>
					</Grid>
				</Grid>

				<Dialog open={archiveDialogOpen} onClose={this.handleArchiveCancel}>
					<DialogTitle>Archive Railcar</DialogTitle>
					<DialogContent>
						<DialogContentText>
							NOTE: If this railcar is still in the google sheets it will just come back on the next sync.
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleArchiveCancel} color="primary">
							Cancel
						</Button>
						<Button
							onClick={this.handleArchiveConfirm}
							style={{ color: '#fff', backgroundColor: '#c00' }}
							variant="contained"
						>
							Archive Railcar
						</Button>
					</DialogActions>
				</Dialog>
			</>
		);
	}
	closeInvalidDialog = () => {
		this.setState({ isInvalidOpen: false });
	};
}

RailcarListing.propTypes = {
	classes: PropTypes.object.isRequired,
	railcarSearch: PropTypes.func.isRequired,
	railcarHide: PropTypes.func.isRequired,
	railcars: PropTypes.array,
	terminalMap: PropTypes.object,
	supplierMap: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	resourceMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	authUser: PropTypes.object,
	isExternalReporting: PropTypes.bool,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	RailcarContainer,
])(RailcarListing);
